import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/console/community',
  component: Layout,
  meta: {
    title: '社区',
    menu: false,
  },
  children: [
    {
      path: '',
      name: 'community',
      component: () => import('@/views/community/index.vue'),
      meta: {
        title: '社区',
        menu: false,
        breadcrumb: false,
      },
    },
  ],
}

export default routes
